import { InputSwitch } from 'primereact/inputswitch'

/**
 * Toggle con etichetta e testo di stato per la debug console.
 * Sostituisce il blocco switch + span ripetuto in ogni sezione: lo stato acceso è
 * sempre reso allo stesso modo e la conseguenza dell'opzione è dichiarata accanto.
 * @param {Object} props
 * @param {string} props.label - Etichetta del campo
 * @param {boolean} props.checked - Stato corrente
 * @param {Function} props.onChange - Callback con il nuovo valore booleano
 * @param {string} [props.onLabel='ON'] - Testo mostrato quando è attivo
 * @param {string} [props.offLabel='OFF'] - Testo mostrato quando è disattivo
 * @param {string} [props.hint] - Nota sotto il toggle, per spiegare cosa cambia
 * @param {string} [props.span='span 6'] - Colonne occupate nella griglia dei parametri
 */
export function DebugToggle({
  label,
  checked,
  onChange,
  onLabel = 'ON',
  offLabel = 'OFF',
  hint,
  span = 'span 6'
}) {
  return (
    <div className="nfield debug-toggle" style={{ gridColumn: span }}>
      <label>{label}</label>
      <div className="debug-toggle__row">
        <InputSwitch checked={!!checked} onChange={(e) => onChange(e.value)} />
        <span className={`debug-toggle__state ${checked ? 'debug-toggle__state--on' : ''}`}>
          {checked ? onLabel : offLabel}
        </span>
      </div>
      {hint && <span className="debug-toggle__hint">{hint}</span>}
    </div>
  )
}
